import {
    ACTION_GET_COMPANY_CONFIG,
    ACTION_PUT_COMPANY_SURVEY_CONFIG,
    ACTION_PUT_COMPANY_RAFFLE_CONFIG,
    ACTION_GET_WHITE_STAR_VALUES,
} from './types/actions';

import {
    SET_COMPANY_CONFIG,
    SET_WHITE_STAR_VALUES,
} from './types/mutations';

import i18n from '@/plugins/i18n';
import { HapinessService } from '../../../services';

const actions = {
    [ACTION_GET_COMPANY_CONFIG]: async ({ state, commit }, companyId) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                console.log('ACTION_GET_COMPANY_CONFIG - Calling service with:', { idGroup, idEmpresa, idUsuario, companyId });

                HapinessService.getCompanyConfig(idGroup, idEmpresa, idUsuario, companyId)
                    .then(resp => {
                        console.log('ACTION_GET_COMPANY_CONFIG - Response:', resp.data);
                        if (resp.data && resp.data.payload) {
                            commit(SET_COMPANY_CONFIG, resp.data.payload);
                            resolve(resp.data.payload);
                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error('ACTION_GET_COMPANY_CONFIG - Error:', err);
                        if (err.response) {
                            console.error('Error response data:', err.response.data);
                        } else if (err.message) {
                            console.error('Error message:', err.message);
                            if (err.message.includes('CORS') || err.message.includes('Network Error')) {
                                console.error('CORS/Network error detected - backend may not be configured for CORS');
                            }
                        }
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error('ACTION_GET_COMPANY_CONFIG - Exception:', error);
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_PUT_COMPANY_SURVEY_CONFIG]: async ({ state }, { companyId, data }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                HapinessService.putCompanySurveyConfig(idGroup, idEmpresa, idUsuario, companyId, data)
                    .then(resp => {
                        resolve(resp.data);
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_PUT_COMPANY_RAFFLE_CONFIG]: async ({ state }, { companyId, data }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                HapinessService.putCompanyRaffleConfig(idGroup, idEmpresa, idUsuario, companyId, data)
                    .then(resp => {
                        resolve(resp.data);
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_WHITE_STAR_VALUES]: async ({ state, commit }, companyId) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                HapinessService.getWhiteStarValues(idGroup, idEmpresa, idUsuario, companyId)
                    .then(resp => {
                        if (resp.data && resp.data.payload && resp.data.payload.values) {
                            commit(SET_WHITE_STAR_VALUES, resp.data.payload.values);
                            resolve(resp.data.payload.values);
                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },
};

export default actions;
